__turbopack_context__.v({
  "ContainerGrid": "RecentReviewsSection-module-scss-module__kiygaa__ContainerGrid",
  "title": "RecentReviewsSection-module-scss-module__kiygaa__title",
});
